/** HTTP base for game backend (port 82 on dev; same origin when UI is served from backend). */
export function getHttpApiBase(): string {
	const apiUrl = (process.env.REACT_APP_API_URL ?? '').replace(/\/$/, '');
	if (!apiUrl) {
		return '';
	}

	const port = (process.env.REACT_APP_PORT ?? '').trim();
	if (apiUrl.startsWith('https://')) {
		return apiUrl;
	}

	if (port && !/:\d+$/.test(apiUrl)) {
		return `${apiUrl}:${port}`;
	}

	return apiUrl;
}

export function apiUrl(path: string): string {
	const base = getHttpApiBase();
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;
	return base ? `${base}${normalizedPath}` : normalizedPath;
}

/** Layer path without extension, e.g. `groundlayer` or `arabian/adult/basecolors/bay`. */
export function bloodlineImageUrl(layerPath: string): string {
	return apiUrl(`/image/horses/bloodlines/${layerPath}.png`);
}

export function starterPreviewImageUrl(starterId: string | number): string {
	return apiUrl(`/image/horses/starter/${starterId}/preview.png`);
}
